import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

export default class Toggler extends React.Component {
  state = {
    isActive: this.props.isActive
  };

  handleChange = (event) => {
    this.setState({
      isActive: event.target.checked
    });

    this.props.onChange(event.target.checked);
  };

  render() {
    const { firstLabel, secondLabel, inversed, center } = this.props;
    const togglerClassName = cx("toggler", {
      "togglerInversed": inversed,
      "togglerCenter": center,
    });
    const firstLabelName = cx("togglerLabel", {
      "togglerLabelActive": this.state.isActive
    });
    const yearLabelClassName = cx("togglerLabel", {
      "togglerLabelActive": !this.state.isActive
    });

    return (
      <div className={togglerClassName}>
        <label className={firstLabelName}>{firstLabel}</label>
        <div className="toggle">
          <input type="checkbox" id="switcher" className="toggleInput" checked={this.state.isActive} onChange={this.handleChange}/>
          <b className="toggleSwitch"/>
        </div>
        <label className={yearLabelClassName}>{secondLabel}</label>
      </div>
    )
  }
}

Toggler.propTypes = {
  firstLabel: PropTypes.string.isRequired,
  secondLabel: PropTypes.string.isRequired,
  inversed: PropTypes.bool,
  center: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
};

Toggler.defaultProps = {
  isActive: false
};
